import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    import("./lib/pwa").then(({ registerClinicalOsServiceWorker }) =>
      registerClinicalOsServiceWorker().catch((error) => console.warn("ClinicalOS PWA registration failed", error))
    );
  });
}
